import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { nextAPIRoutes } from '../constants/apiRoutes'
// import { postAPICall } from '../utils/axios.util'
import { handleSnackBar } from "./global";
import MESSAGES from "../constants/messages";
import dashboardService from "../services/dashboard.service";
import moment from "moment";

export const fetchOwnerListing = createAsyncThunk(
  "dashboard/listing",
  async ({ data }: any, { dispatch }) => {
    try {
      dispatch(setLoadingList(true));
      const resp: any = await dashboardService.fetchListing({ body: data }); //postAPICall(nextAPIRoutes.DASHBOARD_LISTING, data)
      dispatch(setLoadingList(false));
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(setLoadingList(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const getOwnerDashboard = createAsyncThunk(
  "dashboard/getOwnerDashboard",
  async (_, { dispatch }) => {
    try {
      dispatch(setLoadingOwnerData(true));
      const resp: any = await dashboardService.ownerDashboard({ body: {} }); // postAPICall(nextAPIRoutes.OWNER_DASHBOARD, {})
      dispatch(setLoadingOwnerData(false));
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(setLoadingOwnerData(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const getOwnerDashboardStats = createAsyncThunk(
  "dashboard/getOwnerDashboardStats",
  async (data: any, { dispatch }) => {
    try {
      const resp: any = await dashboardService.ownerDashboardStats({
        body: data,
      });
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const getOwnerDashboardBookings = createAsyncThunk(
  "dashboard/getOwnerDashboardBookings",
  async (_, { dispatch }) => {
    try {
      const resp: any = await dashboardService.ownerDashboardBookings({
        body: {},
      });
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const getOwnerDashboardPayouts = createAsyncThunk(
  "dashboard/getOwnerDashboardPayouts",
  async ({ page }: { page: any }, { dispatch }) => {
    try {
      const resp: any = await dashboardService.ownerDashboardPayouts({
        body: { page },
      });
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const deleteEquipment = createAsyncThunk(
  "dashboard/deleteEquipment",
  async ({ id, callback }: any, { dispatch }) => {
    try {
      const resp: any = await dashboardService.deleteEquipment({
        body: { id },
      });
      callback();
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    list: [],
    listMeta: {},
    page: 1,
    selectedType: 0,
    loading: false,
    stats: {
      totalBooking: 0,
      pendingRequest: 0,
      cancel: 0,
      totalListing: 0,
    },
    upcomingBookings: [],
    upcomingBookingsCount: 0,
    pendingRequests: [],
    pendingRequestsCount: 0,
    recentMessages: [
      {
        profileImage: "",
        name: "Lynn Tanner",
        tractor: "Massey Ferguson 241 DI MAHA SHAKTI",
        startDate: "Jul 15",
        endDate: "Aug 15",
        price: "1689.47",
        status: "Pending",
        message: "Where do you plan to go, how many people ?",
        sentAt: "May 18, 2023",
      },
      {
        profileImage: "",
        name: "Lynn Tanner",
        tractor: "Massey Ferguson 241 DI MAHA SHAKTI",
        startDate: "Jul 15",
        endDate: "Aug 15",
        price: "1689.47",
        status: "Expired",
        message: "No messages yet",
        sentAt: "May 18, 2023",
      },
    ],
    payoutHistory: [] as any,
    communication: [
      {
        profileImage: "",
        name: "Albert Robert",
        message:
          "What are the fuel requirements? Determine whether you are responsible for refilling the fuel or if it is included in the rental package.",
        sentAt: "May 18, 2023",
      },
      {
        profileImage: "",
        name: "Mike Torello",
        message: "Hello, How you are?",
        sentAt: "May 18, 2023",
      },
      {
        profileImage: "",
        name: "Sledge Hammer",
        message:
          "What is the cancellation policy? Inquire about the cancellation policy in case your plans change or unforeseen circumstances arise.",
        sentAt: "May 18, 2023",
      },
      {
        profileImage: "",
        name: "Hannibal Smith",
        message:
          "What are the fuel requirements? Determine whether you are responsible for refilling the fuel or if it is included in the rental package.",
        sentAt: "May 18, 2023",
      },
      {
        profileImage: "",
        name: "Albert Robert",
        message:
          "What are the fuel requirements? Determine whether you are responsible for refilling the fuel or if it is included in the rental package.",
        sentAt: "May 18, 2023",
      },
    ],
    bookingContract: [
      {
        id: 587958612,
        startDate: "May 15",
        endDate: "Jul 35",
        profileImage: "",
        name: "Chelsea Powell",
        displayName: "New Holland 3630 TX Plus+ ",
        file: null,
      },
      {
        id: 587958612,
        startDate: "May 15",
        endDate: "Jul 35",
        profileImage: "",
        name: "Chelsea Powell",
        displayName: "New Holland 3630 TX Plus+ ",
        file: null,
      },
      {
        id: 587958612,
        startDate: "May 15",
        endDate: "Jul 35",
        profileImage: "",
        name: "Chelsea Powell",
        displayName: "New Holland 3630 TX Plus+ ",
        file: null,
      },
      {
        id: 587958612,
        startDate: "May 15",
        endDate: "Jul 35",
        profileImage: "",
        name: "Chelsea Powell",
        displayName: "New Holland 3630 TX Plus+ ",
        file: null,
      },
    ],
    ownerResource: [
      {
        name: "Owner Handbook",
        uploadedOn: "May 23, 2023",
      },
    ],
    insuranceAndBooking: [
      {
        name: "Pre-Arrival Checklist",
        uploadedOn: "May 23, 2023",
      },
      {
        name: "Rental Departure Form",
        uploadedOn: "May 23, 2023",
      },
      {
        name: "Pre-Arrival Checklist",
        uploadedOn: "May 23, 2023",
      },
    ],

    ownerDashboard: {},
    loadingOwnerData: false,
    startDate: moment().subtract(30, "days").format("yyyy-MM-DD"),
    endDate: moment().format("yyyy-MM-DD"),
    dashboardStats: {},
    payoutMeta: {},
    payoutPage: 1,
  },
  reducers: {
    setSelectedType: (state, { payload }: { payload: number }) => {
      state.selectedType = payload;
    },
    setLoadingList: (state, { payload }: { payload: boolean }) => {
      state.loading = payload;
    },
    setPage: (state, { payload }: { payload: number }) => {
      state.page = payload;
    },
    setPayoutPage: (state, { payload }: { payload: number }) => {
      state.payoutPage = payload;
    },
    setLoadingOwnerData: (state, { payload }: { payload: boolean }) => {
      state.loadingOwnerData = payload;
    },
    setDateRanges: (state, { payload }: { payload: any }) => {
      state.startDate = payload.start;
      state.endDate = payload.end;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOwnerListing.fulfilled, (state, { payload }) => {
        state.list = payload?.list ?? [];
        state.listMeta = payload?.meta ?? {};
      })
      .addCase(getOwnerDashboard.fulfilled, (state, { payload }) => {})
      .addCase(getOwnerDashboardStats.fulfilled, (state, { payload }) => {
        state.dashboardStats = payload;
      })
      .addCase(getOwnerDashboardBookings.fulfilled, (state, { payload }) => {
        const { upcoming_bookings, pending_bookings } = payload;
        state.upcomingBookings = upcoming_bookings.bookings;
        state.upcomingBookingsCount = upcoming_bookings.count;
        state.pendingRequests = pending_bookings.bookings;
        state.pendingRequestsCount = pending_bookings.count;
      })
      .addCase(getOwnerDashboardPayouts.fulfilled, (state, { payload }) => {
        state.payoutHistory = [
          ...state.payoutHistory,
          ...payload.payouts,
        ].filter((item, index, self) => {
          // Return true only for the first occurrence of each item
          return index === self.findIndex((t) => t.order_id === item.order_id);
        });
        state.payoutMeta = payload.metadata;
      });
  },
});

export default dashboardSlice.reducer;
export const {
  setSelectedType,
  setLoadingList,
  setPage,
  setLoadingOwnerData,
  setPayoutPage,
  setDateRanges,
} = dashboardSlice.actions;
